import { useEffect, useRef } from 'react'
import { fabric } from 'fabric'
import { useFabricJSEditor } from './editor'

const FabricJSCanvas = ({ className, onReady }) => {
  const canvasEl = useRef(null)
  const canvasElParent = useRef(null)

  useEffect(() => {
    const canvas = new fabric.Canvas(canvasEl.current, {
      enablePointerEvents: true,
      stopContextMenu: true,
      selectionKey: 'ctrlKey',
    })
    canvas.enablePointerEvent = true

    const setCurrentDimensions = () => {
      canvas.setHeight(canvasElParent.current?.clientHeight || 0)
      canvas.setWidth(canvasElParent.current?.clientWidth || 0)
      canvas.calcOffset()
      canvas.requestRenderAll()
    }

    setCurrentDimensions()

    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(setCurrentDimensions)
      : null

    if (resizeObserver && canvasElParent.current) {
      resizeObserver.observe(canvasElParent.current)
    }
    else {
      window.addEventListener('resize', setCurrentDimensions, false)
    }

    if (onReady) {
      onReady(canvas)
    }

    return () => {
      resizeObserver?.disconnect()
      canvas.dispose()
      window.removeEventListener('resize', setCurrentDimensions)
    }
  }, [])

  return (
    <div ref={canvasElParent} className={className}>
      <canvas ref={canvasEl} />
    </div>
  )
}

export { FabricJSCanvas, useFabricJSEditor }
